/**
 * Utility functions for text manipulation
 */

/**
 * Truncates a filename to a specified maximum length
 * @param {string} fileName - The filename to truncate
 * @param {number} maxLength - Maximum length (default: 80)
 * @returns {string} - Truncated filename with "..." if needed
 */
export const truncateFileName = (fileName, maxLength = 80) => {
  if (fileName.length <= maxLength) {
    return fileName;
  }
  return fileName.substring(0, maxLength) + "...";
};
